var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTradeIn = function SvgTradeIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.53 3.019a.4.4 0 0 0-.561.57l2.917 2.877H7a.4.4 0 1 0 0 .8h7.902l-2.943 3.117a.4.4 0 0 0 .582.55L15.8 7.48a.9.9 0 0 0-.023-1.258l-3.246-3.203ZM5 7.266h1a.4.4 0 1 0 0-.8H5a.4.4 0 1 0 0 .8Zm10.4 5.6a.4.4 0 0 1-.4.4h-1.024a.4.4 0 0 1 0-.8H15c.221 0 .4.18.4.4Zm-2.048 0a.4.4 0 0 1-.4.4h-7.89l2.98 3.156a.4.4 0 0 1-.582.549L4.2 13.519a.9.9 0 0 1 .023-1.259l3.246-3.203a.4.4 0 0 1 .562.57l-2.879 2.84h7.8c.22 0 .4.179.4.4Z",
    fill: "currentColor"
  })));
};
export default SvgTradeIn;